import { createFileRoute } from '@tanstack/react-router'
import { MyQuotesPage } from '@/features/quote-builder/overview/my-quotes-page'

export const Route = createFileRoute('/_authenticated/quotes/')({
  staticData: { title: 'My Quotes' },
  component: MyQuotesPage,
})
